import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import { SpacingProps } from '@sdk/components/ui/spacing/Spacing';

type ContainerProps = {
  noMinHeight?: boolean;
};
export const Container = styled(Column)<ContainerProps & SpacingProps>`
  flex-shrink: 1;
  box-sizing: border-box;
  width: 580px;
  max-width: 580px;
  ${({ noMinHeight = false }) => (noMinHeight ? '' : 'min-height: 404px')};
  padding-top: ${({ pTop }) => `${pTop || 20}px`};
  padding-bottom: ${({ pBottom }) => `${pBottom || 20}px`};
  padding-left: ${({ pLeft }) => `${pLeft || 5}px`};
  padding-right: ${({ pRight }) => `${pRight || 5}px`};
`;

export const CenterContentRow = styled(Row)`
  width: 100%;
  justify-content: center;
`;

export const ModalContent = styled(Column)`
  flex: 1;
`;

export const FooterRow = styled(Row)`
  justify-content: flex-end;
  padding-left: 15px;
  padding-right: 15px;
`;

export const ButtonContainer = styled(Row)`
  width: 140px;
`;

export const ScrollableArea = styled(Column)<{ maxHeight: number } & SpacingProps>`
  max-height: ${({ maxHeight }) => maxHeight}px;
  overflow-x: hidden;
  overflow-y: auto;
`;
